import { ViewerFeatureFlagsDocument } from './__generated__/feature-flags.zeus';
import { requestZeusReadFromBrowser } from './zeusBrowserClient';

export const getFeatureFlag = async ({ key, signal }: { key: string; signal?: AbortSignal }) => {
  const result = await requestZeusReadFromBrowser(
    ViewerFeatureFlagsDocument,
    { keys: [key] },
    signal,
  );
  const flags = result.viewer.featureFlags;
  if (flags === null) {
    throw new Error(`Feature flag evaluation unavailable: ${key}`);
  }
  return flags.find((flag) => flag.key === key)?.value ?? null;
};
